<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section id="about">
            <br>
            <header><h3>History and Archaeology Students' Society</h3></header>
            <img src="assets/img/history_and_archaeology_students_society_uor.jpg">
            <hr>
            <p>
              History and Archaeology students' society can be called the official association of the Department of
              History and Archeology students. It was established on 02 July 1990 as the "History Society". After adding
              the subject of archaeology, its name was changed to History and the Archaeology Student's Society. This
              society is dedicated to improving the university academic experience, professional development and social
              activities throughout the academic year for the students who study history and archaeology. As an academic
              institutional student society, It has made room to give students a voice and a platform to express new
              ideas and thoughts regarding all aspects of the academic and research environment. By publishing the
              academic journal AVALOKAN, the society entirely contributes to enhancing research and academic discipline
              regarding both disciplines of History and Archaeology.
            </p>
            <hr>
            <h4>Objectives</h4>
            <ul class="element-framed">
              <li>To conduct programmes to enhance theoretical and practical knowledge of the human past among students
              </li>
              <li>To create dynamic leaders capable of serving the community</li>
              <li>To improve the academic capabilities of the students by encouraging academic writings</li>
              <li>To develop ethical concerns and positive attitudes among students within the disciplinary background
              </li>
              <li>To establish connectivity with the society bearing multicultural heritage concerns</li>
            </ul>
            <hr>
            <h4>Activities - ISIMBU PANHIDA</h4>
            <p>
              The History and Archaeology students' society a creative competition called Isimbu Panhida has been
              organized. The competition is designed to hone the academic and creative abilities of students in the
              Department of History and Archaeology and the Faculty of Humanities and Social Sciences. Furthermore,
              through organizing this kind of competition, students' society will be expecting to give amplification
              opportunity to rationally thinking and sensitive on consciously with creative ideology for the students.
            </p>
          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <br>
          <aside id="our-professors">
            <header>
              <h5>Office Bearers</h5>
            </header>
            <div class="section-content">
              <div class="professors">
                <aside>
                  <header>
                    <b>Advisory Board</b>
                    <figure class="professor-description">Dr G. C. L. Gamage<br>Head of the Department, Department of H & A</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>President</b>
                    <figure class="professor-description">Mr. H.A. Sampath Harshana</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Secretary</b>
                    <figure class="professor-description">Mr. H.K. Pabasara</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Vice President</b>
                    <figure class="professor-description">Mr. W.P.I.L. Wickramasinghe</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Co-Secretary</b>
                    <figure class="professor-description">Ms. T.H.M.D. Mekala</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Senior Treasurer</b>
                    <figure class="professor-description">Dr. J.K.A. Kanthi (Senior Lecturer)</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Treasurer</b>
                    <figure class="professor-description">Ms. D.G.S.I. Piyathissa</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Main Editor</b>
                    <figure class="professor-description">Ms. H. Nethma Aravindi Silva</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Co- Editors</b>
                    <figure class="professor-description">
                      Ms. K.P. Hashini Shalika Dayarathna<br>
                      Ms. K.W.R. Ruksha Chamudika Thathsarani<br>
                      Mr. K.T.R.S.Kiriella<br>
                      Ms. H.K S.D Amaranath<br>
                      Mr. J.V.P.M. Viddyarathna<br>
                      Mr. W.M.S.P Jinadasa
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Committee Members</b>
                    <figure class="professor-description">
                      Rev. D. Buddhasara<br>
                      Mr. T.M.D.N Bandara<br>
                      Mr. U.K.Ushan Sandakalum<br>
                      Ms. K.D.Asha Subhashani Dayananda<br>
                      Ms. M.H. Thanuji Rangika<br>
                      Mr. S.M.A.P. Rathnasiri<br>
                      Mr. K.M. Chathuranga prabhath<br>
                      Mr.  S.A.D.S. Jayasinghe<br>
                    </figure>
                  </header>
                </aside>
              </div><!-- /.professors -->
            </div><!-- /.section-content -->
          </aside><!-- /.our-professors -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
